export default {
  path: '/more',
  name: 'More',
  meta: {
    title: '工具',
    showTabBar: true
  },
  redirect: {
    name: 'MoreList'
  },
  component: () => import('@/views/layout/HomeLayout'),
  children: [
    {
      path: 'more-list',
      name: 'MoreList',
      meta: {
        title: '常用工具',
        showTabBar: true
      },
      component: () => import('@/views/More')
    },
    {
      path: 'ban-fertilizer',
      name: 'BanFertilizer',
      meta: {
        title: '禁用农药清单'
      },
      component: () => import('@/views/More/BanFertilizer')
    },
    {
      path: 'potion-calculation',
      name: 'PotionCalculation',
      meta: {
        title: '用药兑水计算'
      },
      component: () => import('@/views/More/PotionCalculation')
    },
    {
      path: 'agriculture',
      name: 'ToolAgriculture',
      meta: {
        title: '查农资'
      },
      component: () => import('@/views/More/Agriculture')
    },
    {
      path: 'agriculture/:type',
      name: 'ToolAgricultureSearch',
      props: true,
      meta: {
        title: '查农资'
      },
      component: () => import('@/views/More/Agriculture/Search')
    },
    {
      path: 'limit-fertilizer',
      name: 'LimitFertilizer',
      meta: {
        title: '限用农药清单'
      },
      component: () => import('@/views/More/LimitFertilizer')
    },
    {
      path: 'disease-pest',
      name: 'DiseasePest',
      meta: {
        title: '病虫草害防治'
      },
      component: () => import('@/views/More/DiseasePest')
    },
    {
      path: 'disease-pest/crop',
      name: 'DiseasePestCrop',
      meta: {
        title: '病虫草害防治作物'
      },
      component: () => import('@/views/More/DiseasePest/Crop')
    },
    {
      path: 'disease-pest/detail/:id',
      name: 'DiseasePestDetail',
      props: true,
      meta: {
        title: '病虫草害防治详情'
      },
      component: () => import('@/views/More/DiseasePest/Detail')
    },
    {
      path: 'tally-book',
      name: 'TallyBook',
      meta: {
        title: '记账本'
      },
      component: () => import('@/views/More/TallyBook')
    }

  ]
}
